import moment from "moment";
import Vue from "vue";
import Clipboard from "clipboard";

export const tencentMapKey = "S2DBZ-W6S6B-KRXUN-NHF2N-DE2U6-7UBBD"; // 腾讯地图key


export function formatDateOne (date,val) {
	  let y = date.getFullYear();
	  let m = date.getMonth()+1;
	  let d = date.getDate();
	  let h = date.getHours();
	  let mm = date.getMinutes();
	  let s = date.getSeconds();
	  if(m <= 9){
	  	m = '0' + m;
	  }
	  if(d <= 9){
	  	d = '0' + d;
	  }
	  if(h <= 9){
	  	h = '0' + h;
	  }
	  if(mm <= 9){
	  	mm = '0' + mm;
	  }
	  if(s <= 9){
	  	s = '0' + s;
	  }
		
		let tmpTime = '';
		if(val == 0){
			tmpTime = `${h}:${mm}`;
		}else if(val == 1){
			tmpTime = `${m}-${d}`;
		}else if(val == 2){
			tmpTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
		}else if(val == 3){
			tmpTime = `${y}-${m}-${d}`;
		}else if(val == 4){
			tmpTime = `${y}-${m}-${d} ${h}:${mm}`;
		}
	    return tmpTime;
	};

/**
 * 封装树形结构
 * @param roleArr 【[[2,8],[2,9]]】
 * @param resultArr 返回的结果
 */
export function encapsulationMenus(roleArr, resultArr) {
  if (!roleArr || roleArr.length === 0) {
    return resultArr;
  }
  let oneStr = ":";
  roleArr.map(item => {
    // 下层还有数组
    if (item instanceof Array) {
      encapsulationMenus(item, resultArr);
    } else {
      oneStr += item + ":";
    }
  });
  if (oneStr !== ":") {
    resultArr.push(oneStr);
  }
  return resultArr;
}
/**
 * 拆分树形结构
 * @param roleStr 【[":2:9:12:"]】
 */
export function splitMenus(roleStr) {
  const resultArr = [];
  if (!roleStr) {
    return resultArr;
  }
  const roleStrArr = roleStr.split(",");

  roleStrArr.map(item => {
    const arr = [];
    const strArr = item.split(":");
    // 多级
    if (strArr instanceof Array) {
      strArr.map(o => {
        if (o) {
          arr.push(parseInt(o, 10));
        }
      });
    } else {
      arr.push(parseInt(item, 10));
    }
    resultArr.push(arr);
  });
  return resultArr;
}

export function formatDateTime(dateTime) {
  // return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
  if (dateTime === null || dateTime === undefined) {
    return "";
  }
  const d = new Date(dateTime);
  d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
  const aa = d.toISOString();
  return aa.slice(0, 19).replace("T", " ");
}

export function formatApiDate(dateTime) {
  if (dateTime === null || dateTime === undefined) {
    return "";
  }
  if (typeof dateTime === "number") {
    return formatDateTime(dateTime);
  } else {
    return dateTime.slice(0, 19).replace("T", " ");
  }
}

/**
 * 获取文件
 */
export function getFileName(path) {
  let fileName = "";
  if (!path) {
    return fileName;
  }
  const pathArr = path.split("/");
  fileName = pathArr[pathArr.length - 1];
  return fileName;
}

/**
 * 转换时间格式
 * @param date 时间格式
 * @returns {string}
 */
export function formatDate1(date) {
  if (!date) {
    return "";
  }
  return moment(date).format("HH:mm");
}

function clipboardSuccess() {
  Vue.prototype.$message({
    message: "复制成功",
    type: "success",
    duration: 1500
  });
}

function clipboardError() {
  Vue.prototype.$message({
    message: "复制失败",
    type: "error"
  });
}

export function handleClipboard(event, text) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  });
  clipboard.on("success", () => {
    clipboardSuccess();
    clipboard.destroy();
  });
  clipboard.on("error", () => {
    clipboardError();
    clipboard.destroy();
  });
  clipboard.onClick(event);
}

/**
 * 获取表格的缩略图
 * @param path 需要封装的路径
 * @param width 宽度固定，高度自适应缩小
 * @param height 高度固定，宽度自适应缩小
 * @returns {null|string}
 */
export function getTableThumbnailImg(path, width, height) {
  if (!path) {
    return path;
  }
  let resultPath = path + "?x-oss-process=image/resize,";
  if (width) {
    resultPath += "w_" + width;
  }
  if (height) {
    resultPath += ",h_" + height;
  }
  if (!width && !height) {
    resultPath += "w_100";
  }
  return resultPath;
}
